import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { TooltipPosition, TooltipPositionX, TooltipPositionY } from 'fc-ui-components';

@Component({
    selector: 'fcp-ellipsis-tooltip-text',
    templateUrl: './ellipsis-tooltip-text.component.html',
    styleUrls: ['./ellipsis-tooltip-text.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EllipsisTooltipTextComponent implements AfterViewInit {
    @ViewChild('contentDiv') contentDivRef!: ElementRef;
    @Input() text: string;
    public isTooltipOpen = false;
    public tooltipPosition: TooltipPosition = {
        originX: TooltipPositionX.Center,
        originY: TooltipPositionY.Top
    };
    public isOverflowing = false;
    constructor() {}

    ngAfterViewInit(): void {
        this.checkOverflow();
    }

    public checkOverflow(state = false): void {
        const contentDiv = this.contentDivRef.nativeElement;
        this.isOverflowing = contentDiv.scrollWidth > contentDiv.clientWidth;
        this.isTooltipOpen = this.isOverflowing && state;
    }
}
